import { useEffect, useState } from 'react';

import { getI18n } from 'react-i18next';
import { fetchApi } from 'utils/fetchApi';

import { useUserOrganization } from '~/features/organizations/hooks/useUserOrganization';

// 👇 The Look ID for the Survey Results
const LOOKER_SURVEY_RESULTS_REPORT_ID = 354;

export type SurveyResultsState = {
  looker: {
    loading: boolean;
    url: string | null;
    error?: string;
  };
};
const initialState: SurveyResultsState = {
  looker: {
    loading: false,
    url: null,
  },
};

/**
 * Handle business logic related to the Survey Results
 *
 * @returns useSurveyResults State
 */
export function useSurveyResults() {
  const { language } = getI18n();
  const { organizationData, isLoading, error } = useUserOrganization();
  const [looker, setLooker] = useState<SurveyResultsState['looker']>(initialState.looker);

  useEffect(() => {
    let stale = false;
    async function fetchLookerURL(language: string) {
      setLooker({
        loading: true,
        url: null,
      });
      try {
        const result = await fetchApi(`/api/lookerDashboardUrlById?lang=${language}&id=${LOOKER_SURVEY_RESULTS_REPORT_ID}`, {
          method: 'GET',
        });
        const data = (await result.json()) as { url: string };
        if (!stale) {
          setLooker({
            loading: false,
            url: data.url,
          });
        }
      } catch (error) {
        console.error(`Failed to fetch Looker URL: ${error}`);
        if (!stale) {
          setLooker({
            loading: false,
            url: null,
            error: String(error),
          });
        }
      }
    }
    fetchLookerURL(language);

    return () => {
      stale = true;
    };
  }, [language]);

  return { org: organizationData, looker, isLoading, error };
}
